import { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Button from "../../components/form-controls/Button";
import InvalidFeedback from "../../components/InvalidFeedback";
import Tags from "../../components/Tags";
import { useTranslation } from "react-i18next";

function FormConnectionPage({ connection, onDelete, onUpdate }) {
    const { t } = useTranslation();
    const defaultValues = {
        keywords: []
    }

    const { control, getValues, setValue, handleSubmit, formState: { errors, isValid, isSubmitting } } = useForm({
        mode: 'onChange',
        defaultValues
    });

    const initialValues = useMemo(() => {
        const fixedValue = connection.edge.sourceHandle;
        const parentNode = connection.nodeTarget.data.parent_nodes.find( p => p.node === connection.nodeSource.data._id );
        const keywords$ = parentNode && parentNode.keywords ? parentNode.keywords: [];

        return keywords$.map( k => ({ label: k, value: k, isFixed: k === fixedValue}) );
    }, [connection])

    const submit = async() => {
        try {
            let keywords = getValues('keywords')
            keywords = keywords.length ? keywords: [connection.edge.sourceHandle]

            await onUpdate(
                connection.edge.source,
                connection.edge.target,
                keywords
            )
        } catch (error) {
            
        }
    }

    return (
        <>
            <div className="card-header">
                <h3 className="card-header-title">Conexión entre nodos</h3>
                <p className="m-0"><small className="text-muted">Configura la relación entre dos nodos</small></p>
            </div>
            <div className="card-body">
                <div className="mb-3">
                    <label className="form-label" >Nodo origen</label>
                    <div >
                        <input type="text" className="form-control" value={connection.nodeSource.data.name} disabled />
                    </div>
                </div>
                <div className="mb-3">
                    <label className="form-label" >Nodo objetivo</label>
                    <div >
                        <input type="text" className="form-control" value={connection.nodeTarget.data.name} disabled />
                    </div>
                </div>
                {
                    !(connection.nodeSource.data.type === 'INTERACTIVE' || connection.nodeSource.data.type === 'HTTP') && (
                        <div className="alert alert-soft-secondary text-center">
                            <p>Esta conexión no permite palabras claves porque su nodo padre es de tipo <strong>PREDETERMINADO</strong>.</p>
                        </div>
                    )
                }

                {
                    (connection.nodeSource.data.type === 'INTERACTIVE' || connection.nodeSource.data.type === 'HTTP') && (
                        <>
                            <div className="mb-3">
                                <label className="form-label" >Palabras clave <span className="form-label-secondary">(Escriba algo y pulse enter)</span></label>
                                <Controller
                                    control={control}
                                    name='keywords'
                                    render={({
                                        field: { onChange, value  },
                                        fieldState: { error },
                                    }) => {
                                        

                                        return (
                                            <Tags
                                                isInvalid={!!error}
                                                onChange={(values: any) =>onChange(values)}
                                                initialValue={ initialValues }
                                            />                            
                                        )
                                    }}
                                />
                                <InvalidFeedback error={errors.keywords} />
                            </div>


                            <div className="d-grid gap-2 my-3 ">
                                <Button type="submit" className="btn btn-primary" disabled={!isValid} isLoading={isSubmitting} onClick={handleSubmit(submit)}>{t('btn-save')}</Button>
                            </div>
                        </>
                    )
                }

                

                <div className="d-grid gap-2 my-3 ">
                    <Button type="submit" className="btn btn-ghost-danger" onClick={() => onDelete(connection.edge.source, connection.edge.target)} >Borrar conexión</Button>
                </div>



            </div>
        </>
    )
}
export default FormConnectionPage